// removed by extract-text-webpack-plugin
module.exports = {"portfolioItem":"src-pages----work-module---portfolioItem---2Wn8K","name":"src-pages----work-module---name---39eRk","content":"src-pages----work-module---content---1Uoje","image":"src-pages----work-module---image---30Xwy","copy":"src-pages----work-module---copy---1ob32","type":"src-pages----work-module---type---4Kv3m","url":"src-pages----work-module---url---12Jux","bulletPoints":"src-pages----work-module---bulletPoints---1pVoG","bulletPoint":"src-pages----work-module---bulletPoint---3cWE1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/work.module.css
// module id = 300
// module chunks = 23899280101116